export interface UserProfile {
  id: string;
  username: string;
  email: string;
  firstName?: string;
  lastName?: string;
  isActive: boolean;
  roles: UserRole[];
  lastLogin?: Date;
}

export enum UserRole {
  ADMIN = 'ADMIN',
  EDITOR = 'EDITOR',
  VIEWER = 'VIEWER',
  GUEST = 'GUEST'
}

// También puedes exportar clases si necesitas métodos en tus modelos
export class User implements UserProfile {

  constructor(
    public id: string,
    public username: string,
    public email: string,
    public isActive: boolean,
    public roles: UserRole[],
    public firstName?: string,
    public lastName?: string,
    public lastLogin?: Date
  ) {}

  getFullName(): string {
    if (this.firstName && this.lastName) {
      return `${this.firstName} ${this.lastName}`;
    }
    return this.username;
  }
}
